import { IAccountUser } from '@faire/web-api--source/indigofair/data/IAccountUser';
import { IRetailerAccountUserManagement } from '@faire/web-api--source/indigofair/retailer/IRetailerAccountUserManagement';

export namespace IInviteUserRequest {
  /**
   * Return an instance of IInviteUserRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IInviteUserRequest>
  ): IInviteUserRequest =>
    ({
      ...(partial ?? {}),
    }) as IInviteUserRequest;
}

export interface IInviteUserRequest {
  email: string | undefined;
  first_name: string | undefined;
  last_name: string | undefined;
  /**
   * Replaced with /api/retailer/account-user/{account_user_token}/relationship
   * @deprecated
   */
  subscribe_to_emails: boolean | undefined;
  /**
   * Replaced with invitedRetailerRole.
   * @deprecated
   */
  invited_user_role: keyof typeof IAccountUser.Role | undefined;
  /**
   * The role that this invited user will take.
   */
  invited_retailer_role:
    | keyof typeof IRetailerAccountUserManagement.Role
    | undefined;
}
